import {Component, OnInit} from '@angular/core';
import {SubFormComponent} from '../../_subform';
import {FormBuilder} from '@angular/forms';
import {SpecialistSizesValuesProvider} from '@providers/specialist-sizes-values/specialist-sizes-values.provider';

/**
 * Блок размеров спецодежды
 */

@Component({
    selector: 'specialist-form-fields-clothes',
    templateUrl: './specialist-form-fields-clothes.component.html'
})

export class SpecialistFormFieldsClothesComponent extends SubFormComponent {

    public formGroupTemplate = this._fb.group({
        clothing_size: [''],
        pants_size: [''],
        shoe_size: [''],
        headgear_size: [''],
        glove_size: [''],
        height: [''],
    });

    constructor(
        public sizesProvider: SpecialistSizesValuesProvider,
        private _fb: FormBuilder,
    ) {
        super();
    }
}
